export const TOKEN_COOKIE_NAMES = {
  access: 'TOKEN',
  refresh: 'REFRESH_TOKEN'
} as any;

export const COOKIE_OAUTH_STATE_KEY = 'oAuthState';

export const ONE_YEAR_EXPIRY = 365 * 24 * 60 * 60;

export const PUBLIC_USER_CREDENTIALS = 'pubCreds';

export const ASSETS_NAMES = {
  eur: 'Euro',
  btc: 'Bitcoin',
  eth: 'Ether',
  xrp: 'XRP',
  ltc: 'Litecoin',
  bch: 'Bitcoin Cash',
  link: 'Chainlink',
  uni: 'Uniswap',
  ada: 'Cardano',
  sol: 'Solana',
  dot: 'Polkadot'
};

export const WITHDRAWAL_LIMITS = {
  ada: 1,
  bch: 0.0001,
  btc: 0.0001,
  dot: 1,
  eth: 0.001,
  eur: 0.1,
  link: 3,
  ltc: 0.0001,
  sol: 0.01,
  uni: 1,
  xrp: 20
};

export const THEME_COOKIE_NAME = 'theme';

export const PERCENTAGES = [25, 50, 75, 100];
